var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlayMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2378_6623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 23.6252V11.3748C13.125 10.4759 14.0117 9.91579 14.7178 10.3687L24.2662 16.4939C24.9668 16.9434 24.9668 18.0566 24.2662 18.506L14.7178 24.6312C14.0117 25.0842 13.125 24.5241 13.125 23.6252Z",
    fill: "#4B2B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.38636C25.8364 2.38636 32.6136 9.16364 32.6136 17.5C32.6136 25.8364 25.8364 32.6136 17.5 32.6136C9.16364 32.6136 2.38636 25.8364 2.38636 17.5C2.38636 9.16364 9.16364 2.38636 17.5 2.38636ZM17.5 0C7.82727 0 0 7.82727 0 17.5C0 27.1727 7.82727 35 17.5 35C27.1727 35 35 27.1727 35 17.5C35 7.82727 27.1727 0 17.5 0Z",
    fill: "#4B2B5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2378_6623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayMusicIcon);
export default __webpack_public_path__ + "static/media/videoPlayMusicIcon.f0beaacecc02aad10c5815e4b21fc9de.svg";
export { ForwardRef as ReactComponent };